import React ,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {API_ENDPOINT, BACKEND_URL ,APP_URL, APP_NAME, IMG_URL, amount_format,discount, LIMIT, replaceWithBr,
 showRating} from '../components/config/Common'
 import {Loading} from "components/custom-icons";

import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollPageTop from '../components/ui/ScrollPageTop'

import { BiRupee ,BiMask ,BiTimer } from "react-icons/bi";
import { TfiShield } from "react-icons/tfi";


import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import {Links} from '../routes/PathLink'
import Seo from 'components/seo/seo'

import SearchHome from "./Home/SearchHome";
import NewsHome from "./Home/NewsHome";
import StockAction from "./Home/StockAction";
import YoutubeVideos from "./Home/YoutubeVideos";

//import { useSiteSettings } from 'contexts/site-settings/site-settings';

const Home = ()=> {
	//const  siteSettings  = useSiteSettings();

	/* useEffect(() => {
		console.log('siteSettings===', siteSettings)
	},[]); */
	
	return (
		<ScrollPageTop>
		<Seo 
			title={`${APP_NAME} - NSE & BSE Stock Market Analysis Platform`}
			desc={`Discover top companies with our smart stock screening tool. Analyze financials, valuations, and market trends to make informed investment decisions in India.`}
			url={`${APP_URL}`}
		/>
		<Header hidesearch={true} hidelogo={true} />
		<SearchHome />
		<StockAction />
		<YoutubeVideos />
		<NewsHome />
		<Footer />
		</ScrollPageTop>
		);
	
};


export default Home;
